export default "__VITE_ASSET__DoF92S94__"